import { schoolProfileAPI } from '../services/api';
import { COLLEGE_NAME } from '../branding';

let cachedProfile = null;

// The college details typed under Configuration > College Profile (falls back to the branding name)
export async function getCollegeProfile() {
  if (cachedProfile) return cachedProfile;
  let p = null;
  try { p = (await schoolProfileAPI.get()).data; } catch (e) { p = null; }
  cachedProfile = {
    name: p?.name || COLLEGE_NAME,
    address: p?.address || '',
    phone: p?.contact || '',
    email: p?.email || '',
    website: p?.website || '',
    affiliation: p?.affiliation || '',
    principal: p?.principalName || '',
  };
  return cachedProfile;
}

export function resetCollegeProfileCache() { cachedProfile = null; }

export const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

export const PRINT_CSS = `
  *{margin:0;padding:0;box-sizing:border-box}
  body{font-family:'Segoe UI',Arial,sans-serif;background:#fff;color:#222}
  .no-print{display:flex;justify-content:flex-end;gap:8px;padding:10px 20px;background:#f5f7fa;border-bottom:1px solid #ddd}
  .no-print button{padding:8px 20px;border:none;border-radius:6px;cursor:pointer;font-size:14px;font-weight:600}
  .btn-print{background:#00796b;color:#fff}.btn-close{background:#666;color:#fff}
  table{width:100%;border-collapse:collapse}
  th{background:#00796b;color:#fff;padding:8px 10px;text-align:left;font-size:12px}
  td{padding:6px 10px;border-bottom:1px solid #e0e0e0;font-size:12px;vertical-align:top}
  tr:nth-child(even) td{background:#f7f9f9}
  .r{text-align:right}.c{text-align:center}.b{font-weight:700}
  @media print{.no-print{display:none!important}body{margin:0}}
  .head{text-align:center;padding:18px 20px 14px;background:linear-gradient(135deg,#004d40,#00796b);color:#fff}
  .head h1{font-size:22px;font-weight:700;letter-spacing:.5px}
  .head p{font-size:12px;opacity:.85;margin-top:3px}
  .head h2{font-size:15px;font-weight:600;margin-top:8px;background:rgba(255,255,255,.15);display:inline-block;padding:4px 18px;border-radius:20px}
  .info{display:flex;justify-content:space-between;padding:9px 20px;background:#e0f2f1;border-bottom:1px solid #b2dfdb;font-size:12px;flex-wrap:wrap;gap:4px}
  .info span{font-weight:600;color:#00796b}
  .content{padding:16px 20px}
  .grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px;margin-bottom:16px}
  .card{text-align:center;padding:12px;border-radius:10px;border:1px solid #e0e0e0}
  .card .v{font-size:21px;font-weight:700}.card .l{font-size:11px;color:#666;margin-top:2px}
  .foot{text-align:center;padding:12px;color:#999;font-size:11px;border-top:1px solid #eee;margin-top:20px}
  .sig{display:flex;justify-content:space-between;margin-top:34px;padding:0 20px}
  .sig div{text-align:center;width:170px;border-top:1px solid #333;padding-top:5px;font-size:12px}
  .green{color:#00796b}.red{color:#c62828}.orange{color:#e65100}
  h3{font-size:14px;margin:16px 0 8px;color:#004d40}
`;

export function collegeHeaderHTML(profile, title, subtitle) {
  const lines = [profile.address, [profile.phone, profile.email].filter(Boolean).join('  |  '), profile.affiliation].filter(Boolean);
  return `<div class="head"><h1>${esc(profile.name)}</h1>${lines.map((l) => `<p>${esc(l)}</p>`).join('')}<h2>${esc(title)}</h2>${subtitle ? `<p style="margin-top:8px">${esc(subtitle)}</p>` : ''}</div>`;
}

// Opens a print-ready page (Print / Save as PDF) with the college header on top.
export async function printPage(title, subtitle, bodyHTML, extraCss = '') {
  const profile = await getCollegeProfile();
  const w = window.open('', '_blank', 'width=1100,height=780');
  if (!w) { window.alert('Please allow pop-ups for this site to print.'); return; }
  w.document.write(`<!DOCTYPE html><html><head><title>${esc(title)}</title><style>${PRINT_CSS}${extraCss}</style></head><body>
    <div class="no-print"><button class="btn-print" onclick="window.print()">Print / Save PDF</button><button class="btn-close" onclick="window.close()">Close</button></div>
    ${collegeHeaderHTML(profile, title, subtitle)}
    <div class="content">${bodyHTML}</div>
    <div class="foot">Generated on ${new Date().toLocaleString('en-IN')} &middot; ${esc(profile.name)}</div>
  </body></html>`);
  w.document.close();
}
